// Module
var code = `<div id="schedule-calendar-wrapper">
  <div class="jumbotron-page schedule-calendar-container">
    <div class="schedule-calendar-main">
      <div class="schedule-calendar-frame">
        <div class="schedule-toolbar" ng-style="{ 'border-bottom-color': \$ctrl.scene.color }">
          <div class="schedule-toolbar-group is-start">
            <div class="btn-group btn-group-sm schedule-toolbar-dates" role="group" aria-label="Dates">
              <button type="button" class="btn btn-outline-primary" ng-click="\$ctrl.showPrevious()"
                aria-label="Previous {{ \$ctrl.calendarManager.toolbar.unit }}"
                title="Previous {{ \$ctrl.calendarManager.toolbar.unit }}">
                <i class="fas fa-chevron-left" aria-hidden="true"></i>
              </button>
              <button type="button" class="btn btn-outline-primary" ng-click="\$ctrl.showNext()"
                aria-label="Next {{ \$ctrl.calendarManager.toolbar.unit }}"
                title="Next {{ \$ctrl.calendarManager.toolbar.unit }}">
                <i class="fas fa-chevron-right" aria-hidden="true"></i>
              </button>
            </div>
            <button type="button" class="btn btn-sm btn-outline-primary schedule-toolbar-today" ng-click="\$ctrl.showToday()"
              ng-disabled="\$ctrl.calendarManager.toolbar.todayInView"
              title="{{ \$ctrl.calendarManager.toolbar.unit === 'day' ? 'Today' : 'This week' }}">Today</button>
            <!-- The one dependable way to create an interval. A drag cannot start on an event,
              and a full week has no free ground for a drag. -->
            <button type="button" class="btn btn-sm btn-primary schedule-toolbar-new" ng-click="\$ctrl.inspectNew()"
              aria-label="New interval" title="Create a new interval">
              <i class="fas fa-plus" aria-hidden="true"></i>
              <span class="schedule-toolbar-label">New interval</span>
            </button>
            <!-- Preflight examines the full period of the scene, not only the dates on screen. -->
            <button type="button" class="btn btn-sm btn-outline-primary schedule-toolbar-preflight"
              ng-click="\$ctrl.openPreflight()" aria-label="Preflight" title="Find intervals that never reach the screen">
              <i class="fas fa-clipboard-check" aria-hidden="true"></i>
              <span class="schedule-toolbar-label">Preflight</span>
            </button>
          </div>
          <h2 class="jumbotron-title schedule-toolbar-title">
            <span class="schedule-toolbar-scene" ng-style="{ color: \$ctrl.scene.color }">{{ \$ctrl.scene.name || 'Schedule' }}</span>
            <span class="jumbotron-subtitle schedule-toolbar-range">{{ \$ctrl.calendarManager.toolbar.range }}</span>
          </h2>
          <div class="schedule-toolbar-group is-end">
            <div class="btn-group btn-group-sm schedule-toolbar-zoom" role="group" aria-label="Time resolution">
              <button type="button" class="btn btn-outline-primary" ng-click="\$ctrl.zoom('out')"
                aria-label="Zoom out: coarser time resolution" title="Zoom out: coarser time resolution">
                <i class="fas fa-magnifying-glass-minus" aria-hidden="true"></i>
              </button>
              <button type="button" class="btn btn-outline-primary" ng-click="\$ctrl.zoom('in')"
                aria-label="Zoom in: finer time resolution" title="Zoom in: finer time resolution">
                <i class="fas fa-magnifying-glass-plus" aria-hidden="true"></i>
              </button>
            </div>
            <!-- The operators use no month view and no list view. -->
            <div class="btn-group btn-group-sm schedule-toolbar-view" role="group" aria-label="View">
              <button type="button" class="btn btn-outline-primary" ng-click="\$ctrl.showView('timeGridWeek')"
                ng-class="{ active: \$ctrl.calendarManager.toolbar.viewType === 'timeGridWeek' }"
                aria-pressed="{{ \$ctrl.calendarManager.toolbar.viewType === 'timeGridWeek' }}"
                title="Week view">Week</button>
              <button type="button" class="btn btn-outline-primary" ng-click="\$ctrl.showView('timeGridDay')"
                ng-class="{ active: \$ctrl.calendarManager.toolbar.viewType === 'timeGridDay' }"
                aria-pressed="{{ \$ctrl.calendarManager.toolbar.viewType === 'timeGridDay' }}"
                title="Day view">Day</button>
            </div>
            <button type="button" class="btn-close schedule-toolbar-close" ng-click="\$ctrl.closeCalendar()"
              aria-label="Close the calendar" title="Close the calendar"></button>
          </div>
        </div>
        <div id="schedule-calendar"></div>
      </div>
    </div>
    <schedule-inspector state="\$ctrl.stateManager.panel"
      playlists="\$ctrl.stateManager.availableSceneCollections"
      scene-playlist-ids="\$ctrl.calendarManager.sceneCollectionIds"
      on-edit="\$ctrl.editPanel(\$changes)" on-save="\$ctrl.saveInspector(\$winsPeers)"
      on-delete="\$ctrl.deleteInterval(\$interval)" on-cancel="\$ctrl.closeInspector()"
      on-punch-in="\$ctrl.punchInTakeover()"
      on-open-playlist="\$ctrl.openPlaylist(\$sceneCollectionId)">
    </schedule-inspector>
  </div>
  <preflight-report report="\$ctrl.preflightManager.preflight" scene-name="\$ctrl.scene.name"
    on-close="\$ctrl.closePreflight()" on-highlight="\$ctrl.highlightInterval(\$intervalId)"
    on-open="\$ctrl.openPreflightRow(\$interval)">
  </preflight-report>
</div>
`;
// Exports
export default code;